import MUIQuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import { useContext } from "react";

import { ChartContext } from "../../../Context/ChartContext/ChartContext";
import Card from "../../Card";
import Table from "../../Table";
import Format from "../../../Utility/Format";
import MainContext from "../../../Context/MainContext/MainContext";
import Term from "../../../Utility/Crud/Term";

/**
 * Display a list of notifications.
 * @returns {JSX.Element|null}
 */

const title = "Communications";
const icon = MUIQuestionAnswerIcon;
const className = "CardChartCommunications";

export default function CardChartCommunications() {
    const chartContext = useContext(ChartContext);
    const mainContext = useContext(MainContext);

    const renderContent = () => {
        const whitelistNotificationTypeTermIds = [
            210, // [Service] Approved - Ready to Work: Enter
            92, // Service - Documentation Followup: Enter
            93, // Service - Documentation Followup: Waiting
            94, // Service - Preauth Followup: Enter
            95, // Service - Preauth Followup: Waiting
        ];

        let notifications = Object.values(chartContext.chart.notification).filter(notification => {
            // If on an order, only show order notifications
            if (chartContext.orderId && notification.orderActivityId !== chartContext.orderId) {
                return false;
            }
            if (!(whitelistNotificationTypeTermIds.includes(notification.notificationTypeTermId))) {
                return false;
            }
            return true;
        });

        const columns = [
            { key: "orderActivityId", name: "Order #", type: "string", width: 90 },
            { key: "timestamp", name: "Timestamp", type: "dateTime", width: 170 },
            { key: "recipient", name: "Recipient", type: "string", width: 150 },
            { key: "notificationStatusTermId", name: "Status", type: "term", width: 150 },
            { key: "notificationTypeTermId", name: "Type", type: "string" },
        ];

        const rows = notifications.map(notification => ({
            orderActivityId: notification.orderActivityId,
            id: notification.id,
            timestamp: notification.lastNotificationStatusTermIdChange,
            recipient: notification.notificationChannelTermId === 91 ? Format.phone(notification.recipient) : notification.recipient,
            notificationStatusTermId: notification.notificationStatusTermId,
            notificationTypeTermId: Term.getDisplayName(mainContext.termsIndexed[notification.notificationTypeTermId]),
        }));

        return (
            <Table
                columns={columns}
                rows={rows}
                sort={[{ key: "timestamp", type: "dateTime", direction: "descending" }]}
                showHeader={true}
            />
        );
    };

    return (
        <Card
            renderContent={renderContent}
            getTitle={() => title}
            getIcon={() => icon}
        />
    );
}

CardChartCommunications.meta = { className: className, title: title, icon: icon };

